import { Club, ClubJSON } from '../Club/Club';
import { Jugador } from '../Jugador/Jugador';
import { JugadorXEquipo, JugadorXEquipoJSON } from '../JugadorXEquipo/JugadorXEquipo';

export interface IEquiposDisponiblesJSON {
  club: ClubJSON;
  equipos: EquipoJSON[];
}

export interface IEquiposDisponibles {
  club: Club;
  equipos: Equipo[];
}

export interface EquipoJSON {
  eq_id: string | null;
  eq_nombre: string;
  eq_clubid: number;
  eq_rama: string;
  eq_foto_camiseta_titular: string;
  eq_foto_camiseta_suplente: string;
  eq_activo: boolean;
  eq_catid: number;
  eq_orden: number;
  eq_se_presenta: boolean;
  jugadorXEquipoList: JugadorXEquipoJSON[];
  club: ClubJSON | null;
}

export class Equipo {
  protected constructor(
    private id: string | null,
    private nombre: string,
    private clubid: number,
    private rama: string,
    private fotoCamisetaTitular: string,
    private fotoCamisetaSuplente: string,
    private activo: boolean,
    private catid: number,
    private orden: number,
    private sePresenta: boolean,

    private jugadorXEquipoList: JugadorXEquipo[],
    private club: Club | null
  ) {}

  static createFrom(
    id: string | null,
    nombre: string,
    clubid: number,
    rama: string,
    fotoCamisetaTitular: string,
    fotoCamisetaSuplente: string,
    activo: boolean,
    catid: number,
    orden: number,
    sePresenta: boolean,

    jugadorXEquipoList: JugadorXEquipo[],
    club: Club | null
  ) {
    return new this(
      id,
      nombre,
      clubid,
      rama,
      fotoCamisetaTitular,
      fotoCamisetaSuplente,
      activo,
      catid,
      orden,
      sePresenta,
      jugadorXEquipoList,
      club
    );
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: Equipo) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: EquipoJSON) {
    return Equipo.createFrom(
      entity.eq_id,
      entity.eq_nombre,
      entity.eq_clubid,
      entity.eq_rama,
      entity.eq_foto_camiseta_titular,
      entity.eq_foto_camiseta_suplente,
      entity.eq_activo,
      entity.eq_catid,
      entity.eq_orden,
      entity.eq_se_presenta,
      entity.jugadorXEquipoList ? entity.jugadorXEquipoList.map((e) => JugadorXEquipo.fromJSON(e)) : [],
      entity.club ? Club.fromJSON(entity.club) : null
    );
  }

  toJSON(): EquipoJSON {
    return {
      eq_id: this.getId(),
      eq_nombre: this.getNombre(),
      eq_clubid: this.getClubid(),
      eq_rama: this.getRama(),
      eq_foto_camiseta_titular: this.getFotoCamisetaTitular(),
      eq_foto_camiseta_suplente: this.getFotoCamisetaSuplente(),
      eq_activo: this.getActivo(),
      eq_catid: this.getCatid(),
      eq_orden: this.getOrden(),
      eq_se_presenta: this.getSePresenta(),
      jugadorXEquipoList: this.getJugadorXEquipoList().map((e) => e.toJSON()),
      club: this.getClub() ? this.getClub()!.toJSON() : null,
    };
  }

  getId(): string | null {
    return this.id;
  }

  getNombreOrden(): string {
    var ultimoCaracter = this.nombre.charAt(this.nombre.length - 1);
    return ultimoCaracter !== 'A' ? ultimoCaracter : '';
  }

  getNombre(): string {
    return this.nombre;
  }

  getClubid(): number {
    return this.clubid;
  }

  getRama(): string {
    return this.rama;
  }

  getFotoCamisetaTitular(): string {
    return this.fotoCamisetaTitular;
  }

  getFotoCamisetaSuplente(): string {
    return this.fotoCamisetaSuplente;
  }

  getActivo(): boolean {
    return this.activo;
  }

  getCatid(): number {
    return this.catid;
  }
  getOrden(): number {
    return this.orden;
  }

  getSePresenta() {
    return this.sePresenta;
  }

  getClub(): Club | null {
    return this.club;
  }

  getJugadorXEquipoList(): JugadorXEquipo[] {
    return this.jugadorXEquipoList;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setNombre(value: string): void {
    this.nombre = value;
  }

  setClubid(value: number): void {
    this.clubid = value;
  }

  setRama(value: string): void {
    this.rama = value;
  }

  setFotoCamisetaTitular(value: string): void {
    this.fotoCamisetaTitular = value;
  }

  setFotoCamisetaSuplente(value: string): void {
    this.fotoCamisetaSuplente = value;
  }

  setActivo(value: boolean): void {
    this.activo = value;
  }

  setCatid(value: number): void {
    this.catid = value;
  }
  setOrden(value: number): void {
    this.orden = value;
  }

  nameLike(val: string): boolean {
    if (this.getNombre()) {
      return this.getNombre().toLowerCase().includes(val.toLowerCase());
    } else return false;
  }

  getFullnameClub() {
    return `${this.getClubNombre()} ${this.getNombreOrden()}`;
  }

  getClubNombre() {
    return this.getClub()?.getNombre();
  }
}
